import React from 'react';
import { Link } from 'react-router-dom';
import AppImage from '../AppImage';

const IntroSection = () => {
  return (
    <>
      {/* Desktop Version */}
      <div
        className="hidden md:grid grid-cols-[1fr_2fr] gap-12 mb-12 items-center p-10 rounded-3xl shadow-2xl"
        style={{ backgroundImage: 'linear-gradient(135deg, #C58348 0%, #B073FF 100%)' }}
      >
        <div className="flex justify-center">
          <AppImage
            src="/assets/images/backgrounds/logo_ad_2.png"
            alt="Cosmelytix Logo"
            className="max-h-48 md:max-h-full object-contain"
          />
        </div>
        <div className="flex flex-col justify-center items-center md:items-start">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 text-center md:text-left">
            Simplify your beauty routine with Cosmelytix
          </h1>
          <p className="text-white/90 text-lg md:text-xl leading-relaxed mb-6 text-center md:text-left">
            Tired of spending countless hours searching for the perfect products? Cosmelytix takes the guesswork out of your beauty routine by providing personalized recommendations based on your unique skin passport, preferences, budget, location, sustainability values, and other key parameters. Get tailored suggestions and effortlessly monitor your skin's progress.
          </p>
          <Link
            to="/learn-more"
            className="inline-block px-8 py-3 text-lg font-medium text-white bg-white/20 backdrop-blur-md border border-white rounded-full shadow-lg transition-all duration-300 hover:bg-white hover:text-[#5F40A1] mx-auto md:mx-0"
          >
            Learn more
          </Link>
        </div>
      </div>

      {/* Mobile Version */}
      <div
        className="block md:hidden p-6 mb-8 rounded-2xl shadow-xl flex flex-col items-center"
        style={{ backgroundImage: 'linear-gradient(135deg, #C58348 0%, #B073FF 100%)' }}
      >
        <div className="mb-6 w-3/4">
          <AppImage
            src="/assets/images/backgrounds/logo_ad_2.png"
            alt="Cosmelytix Logo"
            className="w-full h-auto object-contain"
          />
        </div>
        <div className="text-center">
          <h1 className="text-2xl font-bold text-white mb-4">
            Simplify your beauty routine with Cosmelytix
          </h1>
          <p className="text-white/90 text-base leading-relaxed mb-6">
            Tired of spending countless hours searching for the perfect products? Cosmelytix takes the guesswork out of your beauty routine by providing personalized recommendations based on your unique skin passport, preferences, budget, location, sustainability values, and other key parameters. Get tailored suggestions and effortlessly monitor your skin's progress.
          </p>
          <Link
            to="/learn-more"
            className="inline-block px-6 py-3 text-base font-medium text-white bg-white/20 backdrop-blur-md border border-white rounded-full shadow-md transition-all duration-300 hover:bg-white hover:text-[#5F40A1] mx-auto"
          >
            Learn more
          </Link>
        </div>
      </div>
    </>
  );
};

export default IntroSection;
